
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutor/[username]",
      function () {
        return require("private-next-pages/tutor/[username].tsx");
      }
    ]);
  